import { useQuery } from "react-query";
import axios from "infra/http";
import { ContaRecorrenteDadosLancamento } from './../typings';

function useContaRecorrenteDadosLancamento(id: string, mes: string) {
  return useQuery(
    `/v1/conta-recorrente/${id}/dados-lancamento`,
    async () => {
      const { data } = await axios.get<ContaRecorrenteDadosLancamento>(
        `/v1/conta-recorrente/${id}/dados-lancamento`,
        {
          params: {
            mes,
          }
        }
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useContaRecorrenteDadosLancamento;
